import leadershiptraining_background from "../images/leadershiptraining/leadershiptraining_background.png";
import leadershiptraining1 from "../images/leadershiptraining/leadershiptraining1.png";
import leadershiptraining2 from "../images/leadershiptraining/leadershiptraining2.png";
import leadershiptraining3 from "../images/leadershiptraining/leadershiptraining3.png";

export const leadershiptrainingslides = [

/* ---------------- 👑 SLIDE 1 — LEADERSHIP TRAINING INTRO ---------------- */
[
  {
    id: 1,
    type: "background",
    src: leadershiptraining_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 25,
    type: "image",
    src: leadershiptraining1,
    x: 50,
    y: 160,
    width: 200,
    height: 200,
    shape: "circle",
    stroke: "#e03197",
    strokeWidth: 4
  },

  {
    id: 30,
    type: "image",
    src: leadershiptraining2,
    x: 50,
    y: 380,
    width: 200,
    height: 200,
    shape: "circle",
    stroke: "#e03197",
    strokeWidth: 4
  },

  {
    id: 31,
    type: "image",
    src: leadershiptraining3,
    x: 50,
    y: 600,
    width: 200,
    height: 200,
    shape: "circle",
    stroke: "#e03197",
    strokeWidth: 4
  },

  {
    id: 2,
    type: "text",
    text: "👑 Leadership Training",
    x: 230,
    y: 80,
    fontSize: 24,
    fontFamily: "Poppins",
    fill: "#e03197",
  },

  {
    id: 4,
    type: "text",
    text: "Lead • Inspire • Transform",
    x: 290,
    y: 130,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 5,
    type: "text",
    text: "Develop the mindset and skills",
    x: 270,
    y: 200,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 6,
    type: "text",
    text: "needed to become an effective leader",
    x: 260,
    y: 230,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 7,
    type: "text",
    text: "✔ Decision Making",
    x: 280,
    y: 400,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 8,
    type: "text",
    text: "✔ Team Leadership",
    x: 280,
    y: 460,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 9,
    type: "text",
    text: "✔ Strategic Vision",
    x: 280,
    y: 520,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 10,
    type: "text",
    text: "✔ Executive Communication",
    x: 280,
    y: 580,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#e03197"
  }
],


/* ---------------- 📅 SLIDE 2 — EVENT DETAILS ---------------- */
[
  {
    id: 11,
    type: "background",
    src: leadershiptraining_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 12,
    type: "text",
    text: "📌 You're Invited",
    x: 220,
    y: 190,
    fontSize: 28,
    fontFamily: "Open Sans",
    fill: "#e03197"
  },

  {
    id: 13,
    type: "text",
    text: "📅 20 March 2026",
    x: 220,
    y: 250,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 14,
    type: "text",
    text: "⏰ 9:30 AM",
    x: 250,
    y: 300,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 15,
    type: "text",
    text: "📍 Leadership Center, Vijayawada",
    x: 195,
    y: 350,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 16,
    type: "text",
    text: "Lead with Purpose • Inspire Change",
    x: 200,
    y: 500,
    fontSize: 16,
    fontFamily: "Open Sans",
    fill: "#e03197"
  },

  {
    id: 17,
    type: "text",
    text: "Empower yourself today,",
    x: 240,
    y: 550,
    fontSize: 13,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 18,
    type: "text",
    text: "transform organizations tomorrow",
    x: 205,
    y: 600,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#e03197"
  },

  {
    id: 19,
    type: "text",
    text: "👑 Leadership Summit 2026",
    x: 190,
    y: 680,
    fontSize: 22,
    fontFamily: "Dancing Script",
    fill: "#e03197"
  }
]

];